import React from "react";
import { getFinalPrice } from "../utils/purchaseOptions";
import { getCouponTypeLabel, deriveSlabType } from "../utils/couponTypes";

const slabTypeToPurchaseType = {
  piece: "piece",
  pack: "pack",
  cart: "carton",
  extra1: "extra1",
  extra2: "extra2",
  extra3: "extra3",
};

const getCardPurchaseType = (slab) => {
  if (!slab?.type) return null;
  return slabTypeToPurchaseType[slab.type] || null;
};

const getEffectiveSlab = (product, item) => {
  const match = (product.Qtydiscounts || []).find(
    (s) => Number(s.fromqty) === Number(item.qty)
  );
  if (match) return match;
  const derivedType = deriveSlabType(product, item);
  return {
    type: derivedType,
    discount: Number(item.discount || 0),
    fromqty: Number(item.qty),
  };
};

const QuantityDiscountCards = ({ product, selectedCoupon, onSelect, activePurchaseType, disableOthersOnSelect = true }) => {
  const isLoggedIn = Boolean(localStorage.getItem("token"));
  if (!product?.discount_items?.length) return null;

  return (
    <div className="bulk-grid">
      {product.discount_items.map((item, index) => {
        const effectiveSlab = getEffectiveSlab(product, item);
        const slabForCard = (product.Qtydiscounts || []).find(
          (s) => Number(s.fromqty) === Number(item.qty)
        );
        const pricePerItem = getFinalPrice(product, item.qty, effectiveSlab.discount);
        const discountid = slabForCard?.discountid;
        const typeLabel = getCouponTypeLabel(effectiveSlab);
        const extraDiscount = effectiveSlab.discount;
        const productDiscount = Number(product.discount || 0);
        const title = !isLoggedIn
          ? `BUY ${item.qty}`
          : Number(extraDiscount) === 0
            ? `BUY ${item.qty} Get ${productDiscount}% OFF`
            : ` ${productDiscount}% + Extra ${extraDiscount}% OFF`;

        const cardType = getCardPurchaseType(effectiveSlab);
        const isCardDisabled = !!(
          activePurchaseType && cardType && cardType !== activePurchaseType
        );

        const isSelected = selectedCoupon && (
          (selectedCoupon.discountid && Number(selectedCoupon.discountid) === Number(discountid)) ||
          Number(selectedCoupon.qty) === Number(item.qty)
        );

        const isInactive = isCardDisabled || (disableOthersOnSelect && !isSelected && selectedCoupon);

        return (
          <div
            key={index}
            onClick={() => {
              if (isInactive) return;
              if (isSelected) {
                onSelect(null);
                return;
              }
              onSelect({
                ...item,
                qty: Number(item.qty),
                discount: Number(extraDiscount),
                discountid: discountid || undefined,
                type: effectiveSlab.type || null,
                title,
              });
            }}
            className={`bulk-box ${isSelected ? "active" : ""} ${isInactive ? "disabled" : ""}`}
            style={{
              borderColor: isSelected ? "#005487" : isInactive ? "#ddd" : "#E0E0E0",
              backgroundColor: isSelected ? "#F5F9FF" : "#FFFFFF",
              opacity: isInactive ? 0.5 : 1,
              pointerEvents: isInactive ? "none" : "auto",
              cursor: isInactive ? "not-allowed" : "pointer",
            }}
          >
            {isSelected && <span className="bulk-applied-badge">Applied</span>}
            <p className="bulk-title">{title}</p>
            <div className="bulk-info">
              {typeLabel && (
                <span className="bulk-type">{typeLabel}</span>
              )}
              {/* <span className="bulk-divider">|</span> */}
              <span className="bulk-qty">Qty: {item.qty}</span>
            </div>
            <p className="bulk-price">
              ₹{Number(pricePerItem || 0).toFixed(2)}
              <span> Each</span>
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default QuantityDiscountCards;
